import type { ReactNode } from "react";
import { AlertTriangle, CheckCircle2, Info, XCircle } from "lucide-react";
import { cn } from "@/lib/cn";

type Tone = "info" | "good" | "warning" | "critical";

const styles: Record<Tone, { box: string; icon: ReactNode }> = {
  info: { box: "bg-sky-50 text-sky-900 ring-sky-200", icon: <Info className="size-4 shrink-0 text-sky-600" aria-hidden /> },
  good: { box: "bg-green-50 text-green-900 ring-green-200", icon: <CheckCircle2 className="size-4 shrink-0 text-green-600" aria-hidden /> },
  warning: { box: "bg-amber-50 text-amber-900 ring-amber-200", icon: <AlertTriangle className="size-4 shrink-0 text-amber-600" aria-hidden /> },
  critical: { box: "bg-red-50 text-red-900 ring-red-200", icon: <XCircle className="size-4 shrink-0 text-red-600" aria-hidden /> },
};

export function Alert({ tone = "info", title, children, className }: { tone?: Tone; title?: ReactNode; children?: ReactNode; className?: string }) {
  const s = styles[tone];
  return (
    <div className={cn("flex gap-3 rounded-lg px-4 py-3 text-sm ring-1 ring-inset", s.box, className)} role={tone === "critical" ? "alert" : "status"}>
      <div className="pt-0.5">{s.icon}</div>
      <div className="min-w-0 space-y-1">
        {title ? <p className="font-medium">{title}</p> : null}
        {children ? <div className="text-[13px] leading-relaxed opacity-90">{children}</div> : null}
      </div>
    </div>
  );
}
